import React from 'react'

import { MAX_ROOM_LIMIT } from 'constants/offer'
import { connect } from 'react-redux'
import TextButton from 'components/Luxkit/Button/TextButton'
import TextLink from 'components/Luxkit/TextLink'
import SolidPlusIcon from 'components/Luxkit/Icons/solid/SolidPlusIcon'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Caption from 'components/Luxkit/Typography/Caption'
import { rem } from 'polished'
import styled from 'styled-components'
import { Trans, useTranslation } from 'react-i18next'

const ServiceContactBox = styled(BodyText)`
  padding: ${rem(16)};
  background-color: ${props => props.theme.palette.neutral.seven};
`

interface Props {
  className?: string;
  contactNumber?: App.GeoContact;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  roomsCount: number;
  saleUnit?: string;
  maxRooms?: number;
  noServiceContact?: boolean;
  contactBoxStyle?: boolean;
}

function AddRoomButton(props: Props) {
  const {
    className,
    contactNumber,
    onClick,
    roomsCount,
    saleUnit,
    maxRooms = MAX_ROOM_LIMIT,
    noServiceContact,
    contactBoxStyle,
  } = props
  const { t } = useTranslation('common')
  const unit = saleUnit || 'room'

  return (
    <div className={className} data-testid="add-room-button">
      {roomsCount < maxRooms &&
        <TextButton kind="tertiary" outdent="left" startIcon={<SolidPlusIcon />} onClick={onClick}>
          {t('addAnotherSaleUnit', { ns: 'common', count: 0, context: unit, defaultValue: `Add another ${unit}` })}
        </TextButton>
      }
      {(roomsCount >= maxRooms && !noServiceContact && contactNumber) && <>
        {!contactBoxStyle && <Caption variant="medium" weight="bold">
          <Trans i18nKey="bookMoreThan" ns="common" values={{ supportNumber: contactNumber.humanReadable, saleUnit: t('saleUnit', { ns: 'common', count: 8, context: unit, defaultValue: unit }) }}>
            For bookings of more than 8 room please contact our customer service team on{' '}
            <TextLink href={`tel:${contactNumber.number}`} rel="nofollow">
              {contactNumber.humanReadable}
            </TextLink>.
          </Trans>
        </Caption>}

        {contactBoxStyle && <ServiceContactBox variant="medium">
          <Trans i18nKey="addRoomButtonMultipleCabinsContact" ns="common" values={{ supportNumber: contactNumber.humanReadable }}>
            For multiple cabin bookings, please contact our customer service team on{' '}
            <TextLink href={`tel:${contactNumber.number}`} rel="nofollow">
              {contactNumber.humanReadable}
            </TextLink>.
          </Trans>
        </ServiceContactBox>}
      </>}
    </div>
  )
}

function mapStateToProps(state: App.State) {
  return {
    contactNumber: state.geo.currentContact[state.geo.currentContact.default],
  }
}

export default connect(mapStateToProps)(AddRoomButton)
